// Fallback copy for the auth screens. The API returns the same wording,
// these are used when a request fails before the server can answer.
export const AUTH_MESSAGES = {
  invalidCredentials:
    "Invalid username or password. Please check your credentials and try again.",
  resetRequested:
    "If your email is registered, you'll receive a reset link shortly.",
  resetSuccess: "Password reset successfully. You can now log in.",
  resetFailed: "Password reset failed. Please request a new reset link.",
};
